var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJenMembership6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 132",
    width: 80,
    height: 132,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "jen_membership6-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 32h64v64h-64z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #fff2d3 } \r\n\t\t.s1 { fill: #efa986 } \r\n\t\t.s2 { fill: #e6e6e5 } \r\n\t\t.s3 { fill: #f99d1d } \r\n\t\t.s4 { fill: #c9c7ce } \r\n\t\t.s5 { fill: #f9aa2a } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m40 106c-22.1 0-40-17.9-40-40 0-22.1 17.9-40 40-40 22.1 0 40 17.9 40 40 0 22.1-17.9 40-40 40z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m21.1 62.1c2.5-0.6 4.8-1.4 7.1-2.2 1.3-0.4 2.6-0.9 3.8-1.4 2.1-0.9 3.5-2.5 4.6-4.4 1.5-2.7 2.4-5.6 2.9-8.6 0.2-1.2 0.8-1.7 2-1.7 0.3 0.3 0.2 0.7 0.2 1.1q0 4 0 8.1 0 20.9 0 41.8c0 0.4 0.1 0.8-0.2 1.2h-5.9c-4.3-0.8-8.5-2.1-12.8-3.1-0.3-0.1-0.5-0.1-0.6-0.4 0.5-2 0.3-4.1 0.3-6.2q0.1-11.3 0.1-22.5-0.1-0.4-0.1-0.7c0.1-0.5-0.1-0.7-0.6-0.7-0.3 0-0.6 0.1-0.8-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m41.5 96q0-26.1 0-52.2c0.7 0 1.2 0.4 1.7 0.7 2.1 1.3 3.2 3.3 3.4 5.7 0 1.3-0.3 2.5-0.5 3.8-0.5 2.6-1.3 5.1-2.3 7.6q-0.1 0.3-0.2 0.6c0.3 0.1 0.5 0 0.7 0 3.8 0 7.6 0.1 11.5 0 2.4 0 4.2 1.6 4.4 3.8 0.3 2.3-1.2 4.2-3.7 4.7 1.2 0.2 2.1 0.7 2.8 1.5 0.7 0.9 1 1.9 0.9 3 0 2-1.8 3.8-3.9 3.9-1 0-2 0-3.3 0 0.6 0.2 1.1 0.4 1.5 0.6 1.4 0.9 2.3 2.7 1.9 4.4-0.3 1.9-1.8 3.2-3.5 3.4-1.1 0.2-2.1 0-3.4 0.1 1.6 0.6 2.7 1.5 3.1 3 0.6 2.2-0.6 4.5-2.8 5.2-0.1 0.1-0.3 0-0.4 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m21.1 62.1c0.4 0.3 0.9 0.1 1.3 0.1 0.3 0 0.4 0.1 0.4 0.4q-0.1 0.2 0 0.4-0.1 13.5 0 26.9c0 0.9-0.2 1.8-0.5 2.7 0.1 0.4-0.2 0.7-0.4 1-1 1.5-2.4 2.3-4.1 2.4h-8.9c-0.7-0.4-1.3-0.9-1.4-1.8q0-0.5 0-1.1 0-0.4 0-0.9c-0.2-0.2-0.2-0.5-0.2-0.8q0-14.2 0-28.3c0-0.3 0-0.6 0.2-0.9q6.2 0 12.5 0 0.6 0.1 1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m64 55.2c-0.5 1.1-1.4 1.5-2.5 1.4-1 0-2 0-3 0-1.2 0-2-0.8-2-1.9 0-1 0.8-1.8 2-1.8 1 0 2.1 0 3.2-0.1 1.1 0 1.9 0.5 2.3 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.5 62.2q0 15 0 30-2.7 0.1-5.5 0c-1.2 0-2-0.7-2-1.9q0-13.1 0-26.1c0-1.2 0.8-2 2-2q2.7 0 5.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m31.4 43c0 0.5-0.3 1.1-1 1.5-0.6 0.3-1.3 0.3-1.9-0.2q-1.7-1.4-3.1-3.1c-0.6-0.7-0.4-1.8 0.2-2.4 0.7-0.6 1.7-0.7 2.4-0.1 1.1 0.9 2.1 1.9 3.1 3 0.2 0.3 0.3 0.7 0.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m53.4 44.7c-0.7-0.1-1.3-0.4-1.6-1-0.4-0.7-0.4-1.4 0.1-2q1.4-1.7 3.1-3.1c0.7-0.6 1.8-0.4 2.4 0.2 0.6 0.7 0.8 1.7 0.2 2.4-0.9 1.1-2 2.1-3.1 3.1-0.3 0.3-0.7 0.3-1.1 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m22.7 56.6q-0.9 0-1.8 0c-1.1 0-1.9-0.8-1.9-1.8 0-1.1 0.8-1.9 1.9-1.9q1.9-0.1 3.7 0c1.1 0 1.9 0.8 1.9 1.8 0 1.1-0.8 1.9-1.9 1.9q-0.9 0-1.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m41.5 32c1.1 0 1.9 0.7 1.9 1.8q0 2.1 0 4.1c0 1.1-0.8 1.8-1.9 1.8-0.2-0.2-0.2-0.5-0.2-0.8q0-3 0-6.1c0-0.3 0-0.6 0.2-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m41.5 32q0 3.9 0 7.7c-1.1-0.1-1.9-0.8-1.9-1.9q0-1.9 0-3.9c0-1.1 0.8-1.8 1.9-1.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJenMembership6);
export default __webpack_public_path__ + "static/media/jen_membership6.db91490ea3dbd1ffc4ed7229ea0829c1.svg";
export { ForwardRef as ReactComponent };